import { useEffect, useState } from "react";
import axios from "axios";
import { setDynamicStatuses } from "../components/jobs/jobCardUtils";

const API = process.env.REACT_APP_BACKEND_URL;

let _cache = null;
let _promise = null;

/** Fetch the company's effective job-status list (system + custom), cache it,
 *  and feed jobCardUtils so colors/labels resolve app-wide.
 *  kind: "owner" (dashboard token) | "tech" (technician portal token). */
export const fetchJobStatuses = async (kind = "owner", force = false) => {
  if (_cache && !force) return _cache;
  if (_promise && !force) return _promise;
  const isTech = kind === "tech";
  const token = localStorage.getItem(isTech ? "tech_token" : "token");
  if (!token) return [];
  const url = `${API}/api/${isTech ? "tech/" : ""}job-statuses`;
  _promise = axios
    .get(url, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => {
      _cache = r.data?.statuses || [];
      setDynamicStatuses(_cache);
      return _cache;
    })
    .catch(() => _cache || [])
    .finally(() => { _promise = null; });
  return _promise;
};

export const invalidateJobStatuses = () => { _cache = null; _promise = null; };

export default function useJobStatuses(kind = "owner") {
  const [statuses, setStatuses] = useState(_cache || []);
  useEffect(() => {
    let on = true;
    fetchJobStatuses(kind).then((s) => { if (on && s?.length) setStatuses(s); });
    return () => { on = false; };
  }, [kind]);
  const assignable = statuses.filter((s) => !s.archived);
  const getStatus = (id) => statuses.find((s) => s.id === id);
  return { statuses, assignable, getStatus };
}
